import $ from 'jquery';

const closeSizementTableButton = $('#close-sizement-table');
const openSizementTableButton = $('#sizement-table-button');
const sizementTableComponent = $('.SizementTable');

function close() {
    sizementTableComponent.removeClass('open');
}

function open(ev) {
    ev.preventDefault();

    sizementTableComponent.addClass('open');
}

$(window).on('load', () => {
    sizementTableComponent.addClass('ready');
});

openSizementTableButton.on('click', open);

sizementTableComponent.on('click', close);

$('.SizementTable__box').on('click', function (ev) {
    ev.preventDefault();
    ev.stopImmediatePropagation();
});

closeSizementTableButton.on('click', close);
